import React from "react";
import {
  Card,
  CardContent,
  Grid,
  ButtonBase,
  Typography,
  IconButton,
  Box,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

const StylishCounterCard = ({
  peakPower,
  onPeakPowerChange,
  min = 0,
  max = 100,
  step = 0.5,
}) => {
  const handleIncrement = () => {
    if (peakPower < max) {
      onPeakPowerChange(peakPower + step);
    }
  };

  const handleDecrement = () => {
    if (peakPower > min) {
      onPeakPowerChange(peakPower - step);
    }
  };

  return (
    <Card
      sx={{
        backgroundColor: "#28293e",
        mb: 3,
        px: { xs: 1.5, sm: 4 },
        py: { xs: 2, sm: 5 },
        width: "80%",
      }}
    >
      <CardContent>
        <Typography
          variant="h6"
          gutterBottom
          sx={{ fontSize: { xs: "0.9rem", sm: "1.1rem" } }}
        >
          Set the peak power you can install
        </Typography>
        <Grid container justifyContent="center" spacing={2}>
          <Grid item>
            <ButtonBase
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                p: { xs: 1, sm: 2 },
                backgroundColor: "#1c1c28",
                borderRadius: "8px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                "&:hover": {
                  backgroundColor: "#34344a",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <IconButton
                  onClick={handleDecrement}
                  disabled={peakPower <= min}
                  sx={{
                    color: peakPower <= min ? "#ccc" : "#1976d2",
                    "&:hover": { color: "#115293" },
                  }}
                >
                  <RemoveCircleOutlineIcon fontSize="large" />
                </IconButton>
                <Typography
                  variant="h3"
                  sx={{ fontSize: { xs: "1.5rem", sm: "2rem" }, color: "#fff" }}
                >
                  {peakPower} kW
                </Typography>
                <IconButton
                  onClick={handleIncrement}
                  disabled={peakPower >= max}
                  sx={{
                    color: peakPower >= max ? "#ccc" : "#1976d2",
                    "&:hover": { color: "#115293" },
                  }}
                >
                  <AddCircleOutlineIcon fontSize="large" />
                </IconButton>
              </Box>
            </ButtonBase>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default StylishCounterCard;
